import immutable from 'immutable'
import { FLEETACTHISTORY } from '../actiontype'
const defaultState = immutable.fromJS({
    // 数据
    fleetactArr : [],
    total : 0
})

export const fleetacthistoryReducer = (state = defaultState, action) => {
    switch (action.type) {
        case FLEETACTHISTORY:
            return state.updateIn(['fleetactArr'], _ => (action.data.datas))
                        .updateIn(['total'], _ => (action.data.total))
        default:
            break;
    }
    return state
}